<template>
  <aside
    v-in-viewport.once="() => tracking('promotionImpression')"
    :aria-label="t('main_page.promotions')"
    @click="tracking('promotionClick')"
  >
    <slot />
  </aside>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

type Props = {
  position?: string;
  content: {
    fields: { marketingId: string };
  };
};

const props = withDefaults(defineProps<Props>(), {
  position: '',
});

const { t } = useI18n();
const { $tracking } = useNuxtApp();
const route = useRoute();

const tracking = (eventType: string) => {
  if (props.content.fields.marketingId) {
    const key = getCurrentInstance()?.vnode.key;
    const keyIsIndex = Number.isInteger(key);
    const {
      public: { gtm },
    } = useRuntimeConfig();
    $tracking.emit(eventType, {
      banner: props.content.fields,
      pageType: route.name,
      position: keyIsIndex ? gtm.BANNER_GROUP_POSITION + ((key as number) + 1) : props.position,
    });
  }
};
</script>

<script lang="ts">
export default defineComponent({
  name: 'PromotionTrackingWrapper',
});
</script>
